import { useEffect, useState } from "react";

const useWebinarImage = (imageUrl) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      setIsImageLoaded(false);
      setIsImageLoading(false);
      return;
    }

    setIsImageLoaded(false);
    setIsImageLoading(true);
    const image = new Image();
    image.src = imageUrl;

    image.onload = () => {
      setIsImageLoaded(true);
      setIsImageLoading(false);
    };

    return () => {
      image.onload = null;
    };
  }, [imageUrl]);

  return { isImageLoaded, isImageLoading };
};

export default useWebinarImage;
